import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

export interface DataTableColumn {
    key: string;
    label: string;
    sortable?: boolean;
    type?: 'text' | 'number' | 'date' | 'boolean';
}

export interface DataTableConfig {
    columns: DataTableColumn[];
    pageSize?: number;
    showPagination?: boolean;
    showSearch?: boolean;
    showFilters?: boolean;
    emptyMessage?: string;
}

@Component({
    selector: 'app-data-table',
    templateUrl: './data-table.component.html',
    styleUrls: ['./data-table.component.scss'],
    standalone: false,
})
export class DataTableComponent implements OnInit {
    @Input() config!: DataTableConfig;
    @Input() data: any[] = [];
    @Input() loading = false;
    @Input() totalItems = 0;
    @Input() currentPage = 1;
    @Input() searchTerm = '';
    @Input() selectedFilters: any[] = [];

    @Output() pageChange = new EventEmitter<number>();
    @Output() searchChange = new EventEmitter<string>();
    @Output() filterChange = new EventEmitter<any>();
    @Output() sortChange = new EventEmitter<{ column: string, direction: string }>();

    filteredData: any[] = [];
    sortColumn = '';
    sortDirection = 'asc';

    ngOnInit(): void {
        this.filteredData = [...this.data];
    }

    ngOnChanges(): void {
        this.filteredData = [...this.data];
        this.applyFilters();
    }

    onSearch(event: Event): void {
        const target = event.target as HTMLInputElement;
        this.searchChange.emit(target.value);
    }

    onFilterChange(filter: any, event: Event): void {
        const target = event.target as HTMLInputElement;
        filter.selected = target.checked;
        this.filterChange.emit(filter);
    }

    onSort(column: string): void {
        if (this.sortColumn === column) {
            this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
        } else {
            this.sortColumn = column;
            this.sortDirection = 'asc';
        }
        this.sortChange.emit({ column: this.sortColumn, direction: this.sortDirection });
    }

    onPageChange(page: number): void {
        this.pageChange.emit(page);
    }

    getTotalPages(): number {
        return Math.ceil(this.totalItems / (this.config.pageSize || 10));
    }

    getPagesArray(): number[] {
        const totalPages = this.getTotalPages();
        return Array(totalPages).fill(0).map((_, i) => i + 1);
    }

    private applyFilters(): void {
        // This would be implemented based on specific filtering needs
        // For now, just use the data as-is
        this.filteredData = [...this.data];
    }
}
